import React from "react";
import { Grid } from "@material-ui/core";

const GridContainer = ({ children, ...props }) => (
    <Grid item lg={6} md={6} xs={12} style={{ marginBottom: "1em" }} {...props}>
        {children}
    </Grid>
);

export default GridContainer;
